export const GROUP_NAME_ICONS = {
  Dashboard: "icon-dashboard",
  Jobs: "BriefcaseAltIcon",
  Candidates: "icon-candidate",
  Clients: "icon-user",
  Attachments: "FileUploadAltIcon",
  Invoices: "BillIcon",
  Engagements: "EngagementsIcon",
  Administration: "SettingIcon",
  Roles: "SettingIcon",
  Users: "icon-users",
  "Client Contact": "icon-user-square",
  "Lookup Tables": "icon-lookup",
  "Commission Plans": "icon-commission-plans",
  "Commission Approval": "CommissionApprovalIcon",
  "Commission Statements": "FilePercentageIcon",
  "Client Billing": "icon-user",
  "Client Billing Types": "icon-user",
  "Job Billing Types": "BillIcon",
  "Scheduled Billings": "CalenderIcon",
  "Submit To Billing": "FileUploadAltIcon",
  Reporting: "BarChartOutlined",
  Logs: "ClockIcon",
  "Recruiter Goals": "StarOutlined",
  "Candidate Workflow": "FlowIcon",
};
